
//const imageurl = "http://api.evolve.de/evolvedemopage/api/public/images";
const imageurl = "https://api.evolvejobs.de/demo/api/public/images";

export default imageurl;